import type { State } from "./RegionField";

export const COUNTRY_STATES_DICTIONARY: Record<string, State[]> = {
    "en-MY": [
        { name: "Johor", value: "JOH" },
        { name: "Kedah", value: "KED" },
        { name: "Kelantan", value: "KEL" },
        { name: "Kuala Lumpur", value: "KUL" },
        { name: "Labuan", value: "LAB" },
        { name: "Melaka", value: "MEL" },
        { name: "Pahang", value: "PAH" },
        { name: "Perlis", value: "PEL" },
        { name: "Perak", value: "PER" },
        { name: "Penang", value: "PIN" },
        { name: "Putrajaya", value: "PUT" },
        { name: "Sabah", value: "SAB" },
        { name: "Sarawak", value: "SAR" },
        { name: "Selangor", value: "SEL" },
        { name: "Negeri Sembilan", value: "SER" },
        { name: "Terengganu", value: "TRE" },
    ],
    "en-IN": [
        { name: "Jammu & Kashmir", value: "01" },
        { name: "Himachal Pradesh", value: "02" },
        { name: "Punjab", value: "03" },
        { name: "Chandigarh", value: "04" },
        { name: "Uttarakhand", value: "05" },
        { name: "Haryana", value: "06" },
        { name: "Delhi", value: "07" },
        { name: "Rajasthan", value: "08" },
        { name: "Uttar Pradesh", value: "09" },
        { name: "Bihar", value: "10" },
        { name: "Sikkim", value: "11" },
        { name: "Arunachal Pradesh", value: "12" },
        { name: "Nagaland", value: "13" },
        { name: "Manipur", value: "14" },
        { name: "Mizoram", value: "15" },
        { name: "Tripura", value: "16" },
        { name: "Meghalaya", value: "17" },
        { name: "Assam", value: "18" },
        { name: "West Bengal", value: "19" },
        { name: "Jharkhand", value: "20" },
        { name: "Orissa", value: "21" },
        { name: "Chhattisgarh", value: "22" },
        { name: "Madhya Pradesh", value: "23" },
        { name: "Gujarat", value: "24" },
        { name: "Daman & Diu", value: "25" },
        { name: "Dadra & Nagar Haveli", value: "26" },
        { name: "Maharashtra", value: "27" },
        { name: "Karnataka", value: "29" },
        { name: "Goa", value: "30" },
        { name: "Lakshadweep", value: "31" },
        { name: "Kerala", value: "32" },
        { name: "Tamil Nadu", value: "33" },
        { name: "Puducherry", value: "34" },
        { name: "Andaman & Nicobar Is", value: "35" },
        { name: "Telengana", value: "36" },
        { name: "Andhra Pradesh", value: "37" },
        { name: "Other Territory", value: "97" },
    ],
    "ko-KR": [
        {
            name: "충청북도",
            value: "04",
            englishName: "Chungbuk",
            alias: "Chungcheongbuk",
        },
        {
            name: "충청남도",
            value: "05",
            englishName: "Chungnam",
            alias: "Chungcheongnam",
        },
        {
            name: "강원특별자치도",
            value: "07",
            englishName: "Gangwon",
        },
        {
            name: "경기도",
            value: "09",
            englishName: "Gyeonggi",
        },
        {
            name: "경상북도",
            value: "10",
            englishName: "Gyeongbuk",
        },
        {
            name: "경상남도",
            value: "11",
            englishName: "Gyeongnam",
        },
        {
            name: "전북특별자치도",
            value: "02",
            alias: "Jeonnam",
            englishName: "Jeonbuk",
        },
        {
            name: "전라남도",
            value: "03",
            englishName: "Jeollanam",
        },
        {
            name: "제주특별자치도",
            value: "01",
            englishName: "Jeju",
        },
        {
            name: "서울특별시",
            value: "13",
            englishName: "Seoul",
        },
        {
            name: "부산광역시",
            value: "12",
            englishName: "Busan",
        },
        {
            name: "대구광역시",
            value: "14",
            englishName: "Daegu",
        },
        {
            name: "광주광역시",
            value: "08",
            englishName: "Gwangju",
        },
        {
            name: "인천광역시",
            value: "06",
            englishName: "Incheon",
        },
        {
            name: "대전광역시",
            value: "15",
            englishName: "Daejeon",
        },
        {
            name: "울산광역시",
            value: "16",
            englishName: "Ulsan",
        },
        {
            name: "세종특별자치시",
            value: "17",
            englishName: "Sejong",
        },
    ],
    "en-CA": [
        { name: "Alberta", value: "AB" },
        { name: "British Columbia", value: "BC" },
        { name: "Manitoba", value: "MB" },
        { name: "New Brunswick", value: "NB" },
        { name: "Newfoundland & Labrador", value: "NL" },
        { name: "Nova Scotia", value: "NS" },
        { name: "Northwest Territories", value: "NT" },
        { name: "Nunavut", value: "NU" },
        { name: "Ontario", value: "ON" },
        { name: "Prince Edward Island", value: "PE" },
        { name: "Quebec", value: "QC" },
        { name: "Saskatchewan", value: "SK" },
        { name: "Yukon Territory", value: "YT" },
    ],
    "fr-CA": [
        { name: "Alberta", value: "AB" },
        { name: "Colombie-Britannique", value: "BC" },
        { name: "Manitoba", value: "MB" },
        { name: "Nouveau-Brunswick", value: "NB" },
        { name: "Terre-Neuve-et-Labrador", value: "NL" },
        { name: "Nouvelle-Écosse", value: "NS" },
        { name: "Territoire du Nord-Ouest", value: "NT" },
        { name: "Nunavut", value: "NU" },
        { name: "Ontario", value: "ON" },
        { name: "Île-du-Prince-Édouard", value: "PE" },
        { name: "Quebec", value: "QC" },
        { name: "Saskatchewan", value: "SK" },
        { name: "Yukon", value: "YT" },
    ],
    "en-US": [
        { name: "Alaska", value: "AK" },
        { name: "Alabama", value: "AL" },
        { name: "Arkansas", value: "AR" },
        { name: "Arizona", value: "AZ" },
        { name: "California", value: "CA" },
        { name: "Colorado", value: "CO" },
        { name: "Connecticut", value: "CT" },
        { name: "District of Columbia", value: "DC" },
        { name: "Delaware", value: "DE" },
        { name: "Florida", value: "FL" },
        { name: "Georgia", value: "GA" },
        { name: "Hawaii", value: "HI" },
        { name: "Iowa", value: "IA" },
        { name: "Idaho", value: "ID" },
        { name: "Illinois", value: "IL" },
        { name: "Indiana", value: "IN" },
        { name: "Kansas", value: "KS" },
        { name: "Kentucky", value: "KY" },
        { name: "Louisiana", value: "LA" },
        { name: "Massachusetts", value: "MA" },
        { name: "Maryland", value: "MD" },
        { name: "Maine", value: "ME" },
        { name: "Michigan", value: "MI" },
        { name: "Minnesota", value: "MN" },
        { name: "Missouri", value: "MO" },
        { name: "Mississippi", value: "MS" },
        { name: "Montana", value: "MT" },
        { name: "North Carolina", value: "NC" },
        { name: "North Dakota", value: "ND" },
        { name: "Nebraska", value: "NE" },
        { name: "New Hampshire", value: "NH" },
        { name: "New Jersey", value: "NJ" },
        { name: "New Mexico", value: "NM" },
        { name: "Nevada", value: "NV" },
        { name: "New York", value: "NY" },
        { name: "Ohio", value: "OH" },
        { name: "Oklahoma", value: "OK" },
        { name: "Oregon", value: "OR" },
        { name: "Pennsylvania", value: "PA" },
        { name: "Rhode Island", value: "RI" },
        { name: "South Carolina", value: "SC" },
        { name: "South Dakota", value: "SD" },
        { name: "Tennessee", value: "TN" },
        { name: "Texas", value: "TX" },
        { name: "Utah", value: "UT" },
        { name: "Virginia", value: "VA" },
        { name: "Vermont", value: "VT" },
        { name: "Washington", value: "WA" },
        { name: "Wisconsin", value: "WI" },
        { name: "West Virginia", value: "WV" },
        { name: "Wyoming", value: "WY" },
    ],
    "en-AU": [
        { name: "New South Wales", value: "NSW" },
        { name: "Queensland", value: "QLD" },
        { name: "South Australia", value: "SA" },
        { name: "Tasmania", value: "TAS" },
        { name: "Victoria", value: "VIC" },
        { name: "Western Australia", value: "WA" },
        { name: "Australian Capital Territory", value: "ACT" },
        { name: "Northern Territory", value: "NT" },
    ],
    "en-NZ": [
        { name: "Auckland", value: "AKL" },
        { name: "Bay of Plenty", value: "BOP" },
        { name: "Canterbury", value: "CAN" },
        { name: "Gisborne", value: "GIS" },
        { name: "Hawke's Bay", value: "HAB" },
        { name: "Manawatū-Whanganui", value: "MAN" },
        { name: "Marlborough", value: "MBH" },
        { name: "Nelson", value: "NSN" },
        { name: "Northland", value: "NTL" },
        { name: "Otago", value: "OTA" },
        { name: "Southland", value: "STL" },
        { name: "Taranaki", value: "TAR" },
        { name: "Tasman", value: "TAS" },
        { name: "Waikato", value: "WAI" },
        { name: "West Coast", value: "WEC" },
        { name: "Wellington", value: "WLG" },
    ],
    "ja-JP": [
        { name: "北海道", value: "01", englishName: "Hokkaido" },
        { name: "青森県", value: "02", englishName: "Aomori" },
        { name: "岩手県", value: "03", englishName: "Iwate" },
        { name: "宮城県", value: "04", englishName: "Miyagi" },
        { name: "秋田県", value: "05", englishName: "Akita" },
        { name: "山形県", value: "06", englishName: "Yamagata" },
        { name: "福島県", value: "07", englishName: "Fukushima" },
        { name: "茨城県", value: "08", englishName: "Ibaraki" },
        { name: "栃木県", value: "09", englishName: "Tochigi" },
        { name: "群馬県", value: "10", englishName: "Gunma" },
        { name: "埼玉県", value: "11", englishName: "Saitama" },
        { name: "千葉県", value: "12", englishName: "Chiba" },
        { name: "東京都", value: "13", englishName: "Tokyo" },
        { name: "神奈川県", value: "14", englishName: "Kanagawa" },
        { name: "新潟県", value: "15", englishName: "Niigata" },
        { name: "富山県", value: "16", englishName: "Toyama" },
        { name: "石川県", value: "17", englishName: "Ishikawa" },
        { name: "福井県", value: "18", englishName: "Fukui" },
        { name: "山梨県", value: "19", englishName: "Yamanashi" },
        { name: "長野県", value: "20", englishName: "Nagano" },
        { name: "岐阜県", value: "21", englishName: "Gifu" },
        { name: "静岡県", value: "22", englishName: "Shizuoka" },
        { name: "愛知県", value: "23", englishName: "Aichi" },
        { name: "三重県", value: "24", englishName: "Mie" },
        { name: "滋賀県", value: "25", englishName: "Shiga" },
        { name: "京都府", value: "26", englishName: "Kyoto" },
        { name: "大阪府", value: "27", englishName: "Osaka" },
        { name: "兵庫県", value: "28", englishName: "Hyogo" },
        { name: "奈良県", value: "29", englishName: "Nara" },
        { name: "和歌山県", value: "30", englishName: "Wakayama" },
        { name: "鳥取県", value: "31", englishName: "Tottori" },
        { name: "島根県", value: "32", englishName: "Shimane" },
        { name: "岡山県", value: "33", englishName: "Okayama" },
        { name: "広島県", value: "34", englishName: "Hiroshima" },
        { name: "山口県", value: "35", englishName: "Yamaguchi" },
        { name: "徳島県", value: "36", englishName: "Tokushima" },
        { name: "香川県", value: "37", englishName: "Kagawa" },
        { name: "愛媛県", value: "38", englishName: "Ehime" },
        { name: "高知県", value: "39", englishName: "Kochi" },
        { name: "福岡県", value: "40", englishName: "Fukuoka" },
        { name: "佐賀県", value: "41", englishName: "Saga" },
        { name: "長崎県", value: "42", englishName: "Nagasaki" },
        { name: "熊本県", value: "43", englishName: "Kumamoto" },
        { name: "大分県", value: "44", englishName: "Oita" },
        { name: "宮崎県", value: "45", englishName: "Miyazaki" },
        { name: "鹿児島県", value: "46", englishName: "Kagoshima" },
        { name: "沖縄県", value: "47", englishName: "Okinawa" },
    ],
};
